import React from 'react';
import { motion } from 'framer-motion';
const CEO_IMG = 'https://cdn.magicpatterns.com/uploads/4Pt8wgiecBMMAw2639TFSC/Ally.webp';
export function About() {
  return <section id="about" className="w-full bg-slate-50" data-id="element-16" data-mp="2ptbhice3fvdn">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-32" data-id="element-17" data-mp="2tsam1vvwxq4k">
        <div className="grid items-center gap-8 sm:gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-18" data-mp="2ysokcm7pplpe">
          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2" data-id="element-19" data-mp="33rhvw93fv2mx">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-20" data-mp="3dj5uctyexjxw">
              About Ally
            </span>
            <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate sm:text-4xl" data-id="element-21" data-mp="3mi9f02d8a7ei">
              The Heart Behind the Clean: Ally&apos;s Story
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="relative order-2 mx-auto w-full max-w-md lg:order-1 lg:row-span-2 lg:max-w-none" data-id="element-22" data-mp="2lrh8vv72wf96">
            <div className="aspect-[4/5] overflow-hidden rounded-[2rem] shadow-2xl shadow-slate/20 lg:aspect-auto" data-id="element-23" data-mp="27t0qv83rn2bq">
              <img src={CEO_IMG} alt="Ally, founder of Ally Cleaning Boutique NYC" className="h-full w-full object-cover" data-id="element-24" data-mp="34gxdoupsqtve" />
            </div>
            <div className="absolute -bottom-5 -right-2 rounded-2xl bg-white px-5 py-3 shadow-xl ring-1 ring-slate-100 sm:-right-5 sm:px-6 sm:py-4" data-id="element-25" data-mp="2vnaip6texun9">
              <p className="font-display text-2xl font-extrabold text-magenta" data-id="element-26" data-mp="3o5xxy5lqafgf">
                10+ yrs
              </p>
              <p className="text-xs font-medium uppercase tracking-wide text-slate-muted" data-id="element-27" data-mp="3je7lnu38dhmd">
                Serving NYC homes
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6,
          delay: 0.08
        }} className="order-3 lg:order-3" data-id="element-28" data-mp="b3vi76oaolu1">
            <p className="text-lg leading-relaxed text-slate-soft" data-id="element-29" data-mp="3jk74p9v3bpw7">
              With over 10 years of experience serving New York&apos;s most
              exclusive homes, Ally understands that a clean house is more than
              just organized—it&apos;s a sanctuary. Growing up with a passion
              for order and hospitality, she transformed her dedication into a
              premium boutique service. Ally isn&apos;t just your cleaner; she
              is your strategic partner in home maintenance.
              <br data-id="element-30" data-mp="1ct936h1fdlql" />
              <br data-id="element-31" data-mp="1ctqvj2kyvft8" />
              Known for her meticulous attention to detail and absolute
              discretion, Ally has built a loyal clientele of busy professionals
              and families who trust her with their most private spaces. Her
              philosophy is simple: Luxury is found in the details others miss.
              Whether it&apos;s a pre-event deep clean or your weekly
              maintenance, Ally treats every apartment like a masterpiece.
            </p>
            <div className="mt-6 flex flex-col gap-4 sm:mt-8 sm:flex-row" data-id="element-32" data-mp="3gyzahqgw36dc">
              {[['Eco-friendly', 'Safe for kids, pets & the planet'], ['Fully vetted', 'Trained, insured & background-checked']].map(([title, sub]) => <div key={title} className="flex-1 rounded-2xl bg-white p-5 ring-1 ring-slate-100" data-id="element-33" data-mp="3l1nnmacmyzg4">
                  <p className="font-display font-bold text-slate" data-id="element-34" data-mp="1vosj1rqea7ro">{title}</p>
                  <p className="mt-1 text-sm text-slate-muted" data-id="element-35" data-mp="1qppcu3yohvi4">{sub}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}